import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UniversitiesComponent} from './universities.component';
import {AddUniversityComponent} from './add-university/add-university.component';
import {UniversityLandingComponent} from './university-landing/university-landing.component';
import {UniversityProgramsComponent} from './university-programs/university-programs.component';
import {UniversityCoursesComponent} from './university-courses/university-courses.component';
import {UniversityBranchesComponent} from './university-branches/university-branches.component';
import {UniversityPcbMappingComponent} from './university-pcb-mapping/university-pcb-mapping.component';
import {UniversityInfrastructureComponent} from './university-infrastructure/university-infrastructure.component';
import {UniversityOverviewComponent} from './university-overview/university-overview.component';
import {UniversityContentBlockComponent} from './university-content-block/university-content-block.component';
import {UniversityImportantDateComponent} from './university-important-date/university-important-date.component';
import {UniversityRankingComponent} from './university-ranking/university-ranking.component';
import {UniversityEmiLoanDetailComponent} from './university-emi-loan-detail/university-emi-loan-detail.component';
import {UniversityKeyHighlightComponent} from './university-key-highlight/university-key-highlight.component';
import {UniversityPlacementComponent} from './university-placement/university-placement.component';
import {UniversityWhyChooseDetailComponent} from './university-why-choose-detail/university-why-choose-detail.component';
import {UniversityCareerComponent} from './university-career/university-career.component';
import {UniverityMarketingTagComponent} from './univerity-marketing-tag/univerity-marketing-tag.component';
import {UniversitySuccessStoryComponent} from './university-success-story/university-success-story.component';
import {UniversityFaqComponent} from './university-faq/university-faq.component';
import {UniversityAdmissionComponent} from './university-admission/university-admission.component';
import {UniversityStatComponent} from './university-stat/university-stat.component';
import {UniversityDetailShellComponent} from './university-detail-shell/university-detail-shell.component';
import {UniversityCourseListComponent} from './university-course-list/university-course-list.component';
import {UniversityPopularCoursesComponent} from './university-popular-courses/university-popular-courses.component';

const routes: Routes = [
    {
        path: 'universities',
        component: UniversitiesComponent,
        data: {animation: 'universities'}
    },
    {
        path: 'university/add',
        component: AddUniversityComponent,
        data: {animation: 'university'}
    },
    /*{
        path: 'university/:id/information',
        component: UniversityInformationComponent,
        data: {animation: 'university'}
    },*/
    {
        path: 'university/:id',
        component: UniversityDetailShellComponent,
        data: {animation: 'university'},
        children: [
            {path: 'about', component: UniversityOverviewComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'key-highlights', component: UniversityContentBlockComponent, data: {blockType: 'key_highlights', blockLabel: 'Key Highlights'}},
            {path: 'key-highlights', component: UniversityKeyHighlightComponent},
            {path: 'courses', component: UniversityCoursesComponent},
            {path: 'popular-courses', component: UniversityPopularCoursesComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'important-dates', component: UniversityContentBlockComponent, data: {blockType: 'important_dates', blockLabel: 'Important Dates'}},
            {path: 'important-dates', component: UniversityImportantDateComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'ranking', component: UniversityContentBlockComponent, data: {blockType: 'ranking', blockLabel: 'Ranking'}},
            {path: 'ranking', component: UniversityRankingComponent},
            // Previously routed to the shared placement/EMI stat form:
            // {path: 'emi-loan-details', component: UniversityStatComponent},
            {path: 'emi-loan-details', component: UniversityEmiLoanDetailComponent},
            {path: 'admission-process', component: UniversityAdmissionComponent},
            // Previously routed to the shared placement/EMI stat form:
            // {path: 'placement', component: UniversityStatComponent},
            {path: 'placement', component: UniversityPlacementComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'why-choose', component: UniversityContentBlockComponent, data: {blockType: 'why_choose', blockLabel: 'Why Choose'}},
            {path: 'why-choose', component: UniversityWhyChooseDetailComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'career', component: UniversityContentBlockComponent, data: {blockType: 'career', blockLabel: 'Career'}},
            {path: 'career', component: UniversityCareerComponent},
            // Previously routed to the generic content-block list editor:
            // {path: 'success-stories', component: UniversityContentBlockComponent, data: {blockType: 'success_stories', blockLabel: 'Success Stories'}},
            {path: 'success-stories', component: UniversitySuccessStoryComponent},
            {path: 'faq', component: UniversityFaqComponent}
        ]
    },
    {
        path: 'university-landing/:id',
        component: UniversityLandingComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-landing',
        component: UniversityLandingComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-program/:id',
        component: UniversityProgramsComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-course/:id',
        component: UniversityCourseListComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-branch/:id',
        component: UniversityBranchesComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-pcb-mapping/:id',
        component: UniversityPcbMappingComponent,
        data: {animation: 'university'}
    },
    {
        path: 'university-infrastructure/:id',
        component: UniversityInfrastructureComponent,
        data: {animation: 'university'}
    },
     {
         path: 'university-marketing-tag/:id',
         component: UniverityMarketingTagComponent,
         data: {animation: 'university'}
     }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UniversitiesRoutingModule {
}
